// Document-type categories for Corporate Documents (CompanyFile.documentType).
// Mirrors the backend CompanyFileDocumentType enum. Kept as string literals so it
// does not depend on the generated client enum. No i18n in this portal — labels
// are hardcoded (sentence case, per the plan §3 table).

export const DOCUMENT_TYPE_VALUES = [
  'company_records',
  'accounting',
  'tax_authorities',
  'payroll',
  'contracts',
  'other',
] as const;

export type DocumentType = (typeof DOCUMENT_TYPE_VALUES)[number];

export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  company_records: 'Company records',
  accounting: 'Accounting',
  tax_authorities: 'Tax & authorities',
  payroll: 'Payroll',
  contracts: 'Contracts',
  other: 'Other',
};

// Menu order = table order; default selection in the save popover.
export const DEFAULT_DOCUMENT_TYPE: DocumentType = 'company_records';

export const DOCUMENT_TYPE_OPTIONS = DOCUMENT_TYPE_VALUES.map((value) => ({
  value,
  label: DOCUMENT_TYPE_LABELS[value],
}));

export const getDocumentTypeLabel = (value?: string | null): string | null =>
  value && Object.prototype.hasOwnProperty.call(DOCUMENT_TYPE_LABELS, value)
    ? DOCUMENT_TYPE_LABELS[value as DocumentType]
    : null;
